import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import blueAlertCircleIcon from '@panel/commons/assets/icons/AlertCircleBlue.svg';
import { useOutsideClick } from '../../hooks';
import { isMobileDevice } from '../../helpers';
import TooltipBase from './TooltipBase';

const SecondaryTooltip = ({ children, dataPanel, type, containerLeft, arrowRight, fixedPosition }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [startupAnimation, isStartupAnimation] = useState(true);
  const ref = useRef(null);
  const hoverRef = useRef(null);
  const isMobile = isMobileDevice();

  useOutsideClick(ref, () => showTooltip && setShowTooltip(false));

  useEffect(() => {
    const startTooltip = setTimeout(() => {
      setShowTooltip(true);
    }, 1000);
    const finishTooltip = setTimeout(() => {
      setShowTooltip(false);
      isStartupAnimation(false);
    }, 5200);
    return () => {
      clearTimeout(startTooltip);
      clearTimeout(finishTooltip);
    };
  }, []);

  return (
    <ContentLayout
      onMouseEnter={() => !isMobile && setShowTooltip(true)}
      onMouseLeave={() => !isMobile && setShowTooltip(false)}
    >
      <AlertCircleIcon
        ref={hoverRef}
        src={blueAlertCircleIcon}
        alt=''
        onClick={() => setShowTooltip(true)}
        aria-hidden='true'
      />
      {showTooltip && (
        <ToolContainer>
          <TooltipBase
            ref={ref}
            hoverRef={hoverRef}
            show={showTooltip}
            startupAnimation={startupAnimation}
            withArrow
            dataPanel={dataPanel}
            isSecundary
            containerLeft={containerLeft}
            arrowRight={arrowRight}
            fixedPosition={fixedPosition}
            type={type}
          >
            {children}
          </TooltipBase>
        </ToolContainer>
      )}
    </ContentLayout>
  );
};
const ToolContainer = styled.div`
  position: absolute;
  .label {
    text-align: center;
  }
`;

const AlertCircleIcon = styled.img`
  width: 21px;
  height: 30px;
`;

const ContentLayout = styled.div`
  display: flex;
  margin-left: 10px;
`;

export default SecondaryTooltip;
